const register = {
  loginCredentials: "Prisijungimo kredencialai", // translated 
  companyInformation: "Kompanijos informacija", // translated 
  contactDetails: "Kontaktiniai duomenys", // translated 
  businessName: "Verslo pavadinimas", // translated 
  businessAddress: "Verslo adresas", // translated 
  registrationCode: "Registracijos kodas", // translated 
  websiteUrl: "Svetainės URL", // translated 
  mobilePhone: "Mobilusis telefonas", // translated 
  regionStateProvince: "Regionas/valstybė/provincija", // translated 
  legalTitle: "Teisinis pavadinimas", // translated 
  city: "Miestas", // translated 
  postalCode: "Pašto kodas", // translated 
  registrationSuccess: "Registracija sėkminga.", // translated 
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "Palaukite kelias minutes ir būsite nukreipti į pagrindinį puslapį.", // translated 
};


export default register;
